import React, { useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { Field, Form } from "react-final-form";
import { useNavigate } from "react-router-dom";
import {
  composeValidators,
  preventNonNumericAndRestrictLength,
  renderField,
  required,
} from "../../../helpers/form-validations";
import { meta } from "eslint-plugin-prettier";
import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import { Label } from "../../ui/label";
import {
  createEmployee,
  editEmployee,
  getAllInvestorDetails,
  getSchemesDropdown,
} from "../../../utils/util";
import AdvancedDropdown from "../../ui/multi-selection-dropdown-menu-with-search";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { loaderSet } from '../../../context/actions/loaderAction'
import { alertDanger, alertSuccess } from '../../../context/actions/toastAction'
import { nullEmployeeInfo } from "../../../context/actions/employeeInfoAction";
import Loader from "../../loader";
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/semantic-ui.css'
const CreateEmployee = ({back,getAllEmployee,forWhichUserType="admin",setActiveTab}) => {
  const [errors, setErrors] = useState({
    schemeError: "",
    classError: "",
    investorError: "",
  });
  const navigate=useNavigate()
  const dispatch=useDispatch()

  const allEmailTemplateDetailsForDropdown = useSelector(
    (state) => state.allEmailTemplateDetails
  );
  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([]);
  const [scheme, setScheme] = useState(["option 1", "option 2", "option 3"]);
  const employeeInfo=useSelector(state=>state.employeeInfo)
  // const [allScheme,setAllScheme]=useState([])
  const [selectedClassOptions, setSelectedClassOptions] = useState([]);
  const [selectedInvestorOptions, setSelectedInvestorOptions] = useState([]);
  const [allInvestor, setAllInvestor] = useState([]);
  const [searchParams] = useSearchParams();


const [phoneNumberWithCountryCode,setPhoneNumberWithCountryCode]=useState(  employeeInfo ?   employeeInfo?.mobile_number:null)
 
  const allSchemeDetailsForDropdown = useSelector(
    (state) => state.allSchemeDetails
  );
  const allInvestorDetails = useSelector((state) => state.allInvestorDetails);
  const userId = searchParams.get("user_id");
  const [isLoading,setIsLoading]=useState(false)
  const actionType = searchParams.get("action_type");
  useEffect(() => {
    console.log("User ID:", userId);
    console.log("Action Type:", actionType);
    // You can use these values as needed, for example, making API calls
    // console.log("from redux investor Info",investorInfo)
  }, [userId, actionType]);
  // Function to handle option select/deselect

  const getAllInvestor = async () => {
    const payload = {
      page_no: 1,
      per_page: 10,
      user_type: "investor",
    };
    try {
      const response = await getAllInvestorDetails(payload);
      if (response) {
        console.log(
          "investor data",
          response?.data,
          (response?.data).map((investor, index) => investor.name)
        );
        setAllInvestor(
          (response?.data).map((investor, index) => investor.name)
        );
      }
    } catch (error) {
      console.log("Error in get investor api", error);
    }
  
  };


  // const getAllScheme=async()=>{
  //   try {
  //     const response =await getSchemesDropdown()
  //     console.log("response for gett all schemes dropdown",response.data)
  //     if(response){
  //       setAllScheme(
  //         (response?.data || [])
  //           .filter((scheme) => scheme.scheme_name) // Filters out empty scheme names
  //           .map((scheme, index) => scheme.scheme_name) // Maps only non-empty values
  //       );
  //     }
  //   } catch (error) {
  //     console.log("Error in get all schemes dropdown ",error)
  //   }
  // }

  const [schemeOption, setSchemeOption] = useState(() => {
    return Array.isArray(allSchemeDetailsForDropdown) && allSchemeDetailsForDropdown.length > 0
      ? allSchemeDetailsForDropdown
          .filter(scheme => scheme && scheme.scheme_name) // Filter out null or undefined values and entries without `scheme_name`
          .map(scheme => scheme.scheme_name)
      : [];
  });
  const [classOption, setClassOption] = useState([
   
  ]);
  const [combinationOfSchemeAndClass,setCombinationOfSchemeAndClass]=useState([])

  useEffect(() => {
    if (allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length > 0 && selectedSchemeOptions?.length>0) {
      const filteredClassOptions = allSchemeDetailsForDropdown
        .filter((scheme) => 
          scheme.scheme_name === selectedSchemeOptions[0] && 
          scheme.scheme_class !== undefined && 
          scheme.scheme_class !== null
        )
        .flatMap((scheme) => scheme.scheme_class); // Flatten nested scheme_class arrays
  
      setClassOption(filteredClassOptions);
      console.log("filteredClassOptions",filteredClassOptions)
 
      if (filteredClassOptions.length > 0 && selectedSchemeOptions?.length > 0) {
        const innerBlockCombinationOfSchemeAndClass = filteredClassOptions.map(
          (schemeClass) => `${selectedSchemeOptions[0]}-${schemeClass}`
        );
        console.log("innerBlockCombinationOfSchemeAndClass", innerBlockCombinationOfSchemeAndClass);
      
        // Add only unique combinations that are not already in the array
        setCombinationOfSchemeAndClass((prev) => [
          ...prev,
          ...innerBlockCombinationOfSchemeAndClass.filter(
            (combination) => !prev.includes(combination) // Ensure no duplicates
          ),
        ]);
      }
      
      setSelectedSchemeOptions([]);
      

    }

  }, [allSchemeDetailsForDropdown, selectedSchemeOptions]);
  

  useEffect(() => {
    // Check if distributorInfo and investors are available
    if (employeeInfo?.investors) {
      const transformedArray = Array.isArray(employeeInfo?.schemes) && employeeInfo?.schemes?.length>0 ? employeeInfo?.schemes.flatMap(item => 
        item.scheme.map(s => `${s.scheme_name}-${s.scheme_class}`)
      ):[]
      setCombinationOfSchemeAndClass((prev) => [
        ...prev,
        ...transformedArray.filter(
          (combination) => !prev.includes(combination) // Ensure no duplicates
        ),
      ]);
    }
  }, [employeeInfo]); // Dependency array includes distributorInf
  

  const handleRemoveCombinationOfSchemeAndClass = (indexToRemove) => {
    setCombinationOfSchemeAndClass((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

// useState(()=>{
//   console.log("innerBlockCombinationOfSchemeAndClass",classOption)
 
//   if(classOption.length>0)
//   {
//     const innerBlockCombinationOfSchemeAndClass=classOption.map((schemeClass)=>`${selectedSchemeOptions[0]}-${schemeClass}`)
//    console.log("innerBlockCombinationOfSchemeAndClass",innerBlockCombinationOfSchemeAndClass)
//     setCombinationOfSchemeAndClass(innerBlockCombinationOfSchemeAndClass)
  
//   }

//   setSelectedSchemeOptions([])

// },[classOption])

  useEffect(() => {
    getAllInvestor();
    // getAllScheme()
  }, []);

  const [emailTemplateOption, setEmailTemplateOption] = useState([
   
  ]);
  const [selectedEmailTemplateOptions, setSelectedEmailTemplateOptions] =
    useState([]);

  useEffect(() => {
    if (
      allEmailTemplateDetailsForDropdown &&
      allEmailTemplateDetailsForDropdown.length > 0
    ) {

      const filteredEmailTemplateOptions =
      allEmailTemplateDetailsForDropdown.filter(emailTemplate=>emailTemplate.template_name!==null).map((emailTemplate) => {
        return emailTemplate.template_name;
      });

      setEmailTemplateOption(filteredEmailTemplateOptions);
    }
  }, [allEmailTemplateDetailsForDropdown]);

  const [investorOption, setInvestorOption] = useState([]);
  // useEffect(() => {
  //   if(allInvestorDetails && allInvestorDetails.length>0){
  //     const innerBlockInvestorList = allInvestorDetails
  //     .filter((investor) => {
  //       // Ensure that investor.schemes is an array
  //       if (Array.isArray(investor.schemes)) {
  //         // Check if any of the schemes match the selected scheme and class
  //         return investor.schemes.some((scheme) => {
  //           const schemeMatch = selectedSchemeOptions.includes(
  //             scheme.scheme_name
  //           );
  //           const classMatch = selectedClassOptions.includes(
  //             scheme.scheme_class
  //           );
    
  //           // Only include if both scheme and class match
  //           return schemeMatch && classMatch;
  //         });
  //       }
  //       return false; // If investor.schemes is not an array, exclude the investor
  //     })
  //     .flatMap((investor) =>
        
  //       {
         
  //         console.log("HIIIHIII")
    
  //         return investor.schemes
  //         .filter((scheme) => {
  //           const schemeMatch = selectedSchemeOptions.includes(scheme.scheme_name);
  //           const classMatch = selectedClassOptions.includes(scheme.scheme_class);
  //           console.log("HIIIHIII22222")
  //           // Include only if both scheme and class match
  //           return schemeMatch && classMatch;
  //         })
  //         .map((scheme) => `${scheme.portfolio_number}-${investor.name}`)
        
        
  //       }
    
      
  //     ); // Get the names of filtered investors
    
  //   // Do something with the filtered list (innerBlockInvestorList)
  //   setInvestorOption(innerBlockInvestorList);
  //   console.log("innerBlockInvestorList", innerBlockInvestorList);
  //   }
  // }, [selectedClassOptions, selectedSchemeOptions, allInvestorDetails]);



  const [investorsForDistributor, setInvestorsForDistributor] = useState([]);





  const [ selectedInvestorAgainstSchemeAndClass, setSelectedInvestorAgainstSchemeAndClass]=useState([])
 
  useEffect(() => {
    // Check if distributorInfo and investors are available
    if (employeeInfo?.investors) {
      const initialInvestors = employeeInfo.investors.map(investor => {
        // Extract the scheme and class from each investor
        return investor.schemes.map(scheme => {
          const combinedValue = `${scheme.portfolio_number}-${investor.name}-${scheme.scheme_name}-${scheme.scheme_class}`;
          return combinedValue;
        });
      }).flat(); // Flatten the array of arrays
  
      // Set the initial state without duplicates
      setSelectedInvestorAgainstSchemeAndClass(prev => {
        const newInvestors = initialInvestors.filter(value => !prev.includes(value));
        return [...prev, ...newInvestors];
      });
    }
  }, [employeeInfo]); // Dependency array includes distributorInf
  

  useEffect(()=>{
   if (selectedSchemeOptions?.length>0 && selectedClassOptions?.length>0 && selectedInvestorOptions.length>0){
     const combinedValue = `${selectedInvestorOptions}-${selectedSchemeOptions}-${selectedClassOptions}`;
     setSelectedInvestorAgainstSchemeAndClass((prev) => {
       if (!prev.includes(combinedValue)) {
         return [...prev, combinedValue]; // Add only if it's not a duplicate
       }
       return prev; // If it's already in the array, return the current state
     });
   }
 
//  setSelectedInvestorOptions([])
 

  },[selectedClassOptions,selectedSchemeOptions,selectedInvestorOptions])
 
  const handleRemoveSchemeAndClass = (indexToRemove) => {
   setSelectedInvestorAgainstSchemeAndClass((prev) => prev.filter((_, index) => index !== indexToRemove));
 };
 
 useEffect(() => {
   if (
    // selectedInvestorAgainstSchemeAndClass && selectedInvestorAgainstSchemeAndClass.length > 0
     selectedInvestorAgainstSchemeAndClass
    
  ) {
     // Create an object to accumulate schemes by user_id
     console.log("innerInvestorAgainstSchemeAndClass",selectedInvestorAgainstSchemeAndClass)
     const innerInvestorAgainstSchemeAndClass = selectedInvestorAgainstSchemeAndClass.reduce((acc, item) => {
       // Extract portfolio number
       const portfolioNumber = item.split("-")[0];
       const scheme_name= item.split("-")[2]
       const scheme_class= item.split("-")[3]
 
       // Find the matching user
      //  const matchedUser = allInvestorDetails.schemes.find(
      //   (detail) => detail.portfolio_number === portfolioNumber
      // );
 

      const matchedUser = allInvestorDetails.find((user) => 
        Array.isArray(user.schemes) &&
        user.schemes.some((detail) => detail.portfolio_number === portfolioNumber && detail?.scheme_name===scheme_name && detail?.scheme_class===scheme_class)
      );
      
      // Optional: To get the specific matching scheme details
      const matchedScheme = matchedUser?.schemes.find(
        (detail) => detail.portfolio_number === portfolioNumber
      );
      
      console.log("Matched User:", matchedUser);
      console.log("Matched Scheme:", matchedScheme);
      

       if (matchedUser) {
         // Define the scheme
         const scheme = {
           scheme_name: item.split("-")[2],
           scheme_class: item.split("-")[3]
         };
 
         // If the user_id already exists, push the scheme to the existing array
         const existingUser = acc.find(user => user.user_id === matchedUser.user_id);
         if (existingUser) {
           existingUser.schemes.push(scheme);
         } else {
           // Otherwise, create a new entry with this user and scheme
           acc.push({
             user_id: matchedUser.user_id,
             schemes: [scheme]
           });
         }
       }
 
       return acc;
     }, []);
    setInvestorsForDistributor(innerInvestorAgainstSchemeAndClass)
     console.log("innerInvestorAgainstSchemeAndClass", innerInvestorAgainstSchemeAndClass);
   }
 }, [selectedInvestorAgainstSchemeAndClass, allInvestorDetails]);




  const onSubmit = async (values) => {
    let hasError = false;
    setIsLoading(true)


    // Check for errors
    // if (selectedSchemeOptions.length === 0) {
    //   setErrors((prev) => ({ ...prev, schemeError: "Scheme is required" }));
    //   hasError = true;
    // } else {
    //   setErrors((prev) => ({ ...prev, schemeError: "" }));
    // }

    // if (selectedClassOptions.length === 0) {
    //   setErrors((prev) => ({ ...prev, classError: "Class is required" }));
    //   hasError = true;
    // } else {
    //   setErrors((prev) => ({ ...prev, classError: "" }));
    // }
    // if (allInvestor.length > 0 && selectedInvestorOptions.length === 0) {
    //   setErrors((prev) => ({ ...prev, investorError: "investor is required" }));
    //   hasError = true;
    // } 
    
    // else {
    //   setErrors((prev) => ({ ...prev, investorError: "" }));
    // }

    // If there's any error, stop the form submission
    // if (hasError) return;


    const transformSchemes = (schemes) => {
      // Create a map to group schemes by their base names
      const groupedSchemes = schemes.reduce((acc, scheme) => {
        // Split the scheme into base name and class
        const [scheme_name, scheme_class] = scheme.split("-");
        if (!acc[scheme_name]) {
          acc[scheme_name] = [];
        }
        // Add the class to the respective scheme_name
        acc[scheme_name].push({ scheme_name, scheme_class });
        return acc;
      }, {});
    
      // Convert the grouped schemes into the desired array of objects
      return Object.values(groupedSchemes).map((scheme) => ({ scheme }));
    };

    console.log("investorsForDistributor",investorsForDistributor)

    const payload = {
      user_id: userId ? userId : "",
      email: values?.email || employeeInfo?.user_email,
      user_email: values?.email || employeeInfo?.user_email,
      mobile_number: phoneNumberWithCountryCode || employeeInfo?.mobile_number ,
      user_type: "employee",
      name: values.employeeName || employeeInfo?.name,
      role_name: "employee",
      contact_person_name:values.contact_person_name || employeeInfo?.contact_person_name,
      designation:values.designation || employeeInfo?.designation,
      "template_name":selectedEmailTemplateOptions?.length>0  ?selectedEmailTemplateOptions[0] : null,
       
      // investors:investorsForDistributor 
      investors:transformSchemes(combinationOfSchemeAndClass)
    }
    try {
      if (actionType === "Edit") {
        console.log("valies ", values, "payload", payload);
        const response = await editEmployee(payload);
        console.log("response of add employee", response);
        values.employeeName = "";
        values.email = "";
        values.phoneNumber = "";
        // setSelectedClassOptions([]);
        setSelectedInvestorOptions([]);
        // setSelectedSchemeOptions([]);
          if( response.code ===500){
               dispatch(alertDanger(response.message))
                setIsLoading(false)
               return
             }
             if( response.code ===404){
               dispatch(alertDanger(response.message))
                setIsLoading(false)
               return
             }
             if( response.code ===400){
               dispatch(alertDanger(response.message))
                setIsLoading(false)
               return
             }
        if(response.code===200){
          setActiveTab("employee")
           setIsLoading(false)
          dispatch(alertSuccess("Successfully updated Employee"))
          console.log("values", values);
          dispatch(nullEmployeeInfo())
          getAllEmployee()
          navigate('/admin');
         
          return
        }
      
       
      }
      const response = await createEmployee(payload);
      console.log("response of add employee", response);
      values.employeeName = "";
      values.email = "";
      values.phoneNumber = "";
      // setSelectedClassOptions([]);
      setSelectedInvestorOptions([]);
         if( response.code ===500){
              dispatch(alertDanger(response.message))
               setIsLoading(false)
              return
            }
            if( response.code ===404){
              dispatch(alertDanger(response.message))
               setIsLoading(false)
              return
            }
            if( response.code ===400){
              dispatch(alertDanger(response.message))
               setIsLoading(false)
              return
            }
       if(response.code===200){
        setActiveTab("employee")
         dispatch(alertSuccess("Successfully Created Employee"))
         getAllEmployee()
         dispatch(nullEmployeeInfo())
         navigate('/admin');
         back()
          setIsLoading(false)
          return
        }
      // setSelectedSchemeOptions([]);
      console.log("values", values);
    } catch (error) {
      console.log("Error in add employee", error);
      setIsLoading(false)
    }
    finally {
      // setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    }
  };

  return (
    <>

{
        isLoading && <Loader/>
      }

          { (actionType==="Edit" || actionType==="View") && 
<div className=' w-full flex justify-end items-center ' >
  
   <Button
        variant="outline"
        type="button"
        size="sm"
        className=" h-10  gap-1 text-sm w-max self-start  mt-5 "
        onClick={()=>{
          
          // dispatch(loaderSet(true))
          dispatch(nullEmployeeInfo())
          if(forWhichUserType==="employee"){
            navigate("/employee")
          }
          if(forWhichUserType==="admin"){
            setActiveTab("employee")
            navigate("/admin")
          }
        }
        } 
      >
        <IoIosArrowBack />
        Back
      </Button> 
</div>
      } 
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-8">
      
              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}

                <div className="gap-2 flex flex-col w-[49%]">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="employeeName"
                  >
                    Employee Name <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="employeeName"
                    type="text"
                    name="employeeName"
                    placeholder="Employee Name"
                    // validate={composeValidators(required)}
                      validate={
                          (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                        } 
                    disabled={(actionType==="View" || actionType==="Edit") && true}
                    actionType={actionType}
                    info={employeeInfo && employeeInfo?.name}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
                <div className="gap-2 w-[49%] flex flex-col ">
                   <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="contact_person_name">Contact Person Name</Label>
                     <Field
                       id="contact_person_name"
                       type="text"
                       name="contact_person_name"
                       placeholder="Enter Name"
                       actionType={actionType}
                       info={  employeeInfo &&  employeeInfo?.contact_person_name}
                       disabled={(actionType==="View" ) && true}
                       // validate={
                       //   actionType !== "Edit" ? composeValidators(required) : undefined
                       // }    
                        //  validate={
                        //      (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                        //    }     
                       component={renderField} // Correct usage of renderField
                       className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                     />
                   
                     {meta.touched && meta.error && (
                   <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
                   )}
                   </div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}
                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="email"
                  >
                    Email <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="email"
                    type="text"
                    name="email"
                    placeholder="Enter Email"
                    // validate={composeValidators(required)}
                      validate={
                          (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                        } 
                    disabled={(actionType==="View" || actionType==="Edit") && true}
                    actionType={actionType}
                    info={employeeInfo && employeeInfo?.user_email}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>

                {/* <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="phoneNumber"
                  >
                    Phone Number <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="phoneNumber"
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    // validate={composeValidators(required)}
                    actionType={actionType}
                    disabled={actionType==="View" && true}
                    info={employeeInfo && employeeInfo?.mobile_number}
                    onKeyDown={(event) =>
                      preventNonNumericAndRestrictLength(event, 10)
                    }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div> */}
 <div className="gap-2 w-[49%] flex flex-col ">
    <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="phoneNumber">Phone Number <span className=" text-red-600">*</span> </Label>
    
<div
  style={{
    position: 'relative',
    width: '100%',
    // You can also add media queries for extra control over different screen sizes
  }}
>
  <PhoneInput
    country={'in'} // Set the default country code
    value={phoneNumberWithCountryCode} // Value to display
    onChange={(value) => {
      console.log("Phone Number", value);
      setPhoneNumberWithCountryCode(value);
    }} // Update state on change
    disableSearchIcon
    disabled={actionType === "View"} // Disable the field if actionType is 'View'
    placeholder="Enter phone number"
    enableSearch
    countryCodeEditable={false} // Display the country calling code and make it non-editable

    // Input style
    inputStyle={{
      width: '100%',
      height: '2.25rem',
      padding: '0.5rem',
      paddingLeft: '3.5rem', // Space for the country code button
      borderRadius: '0.375rem',
      border: '1px solid #3a5dd1',
      display: 'inline-block',
      boxSizing: 'border-box',
    }}

    // Country code button style
    buttonStyle={{
      height: '2.25rem',
      width: '3.5rem',
      padding: '0 0.5rem',
      borderLeft: '1px solid #3a5dd1',  // Add border only on the left
      borderTop: '1px solid #3a5dd1',   // Add border only on the top
      borderBottom: '1px solid #3a5dd1', // Add border only on the bottom
      borderRight: 'none',               // Remove border on the right
      outline: 'none',
      boxSizing: 'border-box',
      
      // Border radius
      borderTopLeftRadius: '0.375rem',  // Rounded top-left corner
      borderBottomLeftRadius: '0.375rem', // Rounded bottom-left corner
      borderTopRightRadius: '0',        // Square top-right corner
      borderBottomRightRadius: '0',     // Square bottom-right corner
    }}
    
    

    dropdownStyle={{
      maxHeight: '300px',
      overflowY: 'auto',
    
      top: '100%',
      left: 0,
     
    }}

    // Search bar styles
    searchStyle={{
      width: '100%',
      height: '2.25rem',
      padding: '0.5rem',
      borderRadius: '0.375rem',
      border: '1px solid #3a5dd1',
      boxSizing: 'border-box',
    }}
  />
</div>

      {/* Reserve space for the error message */}
      {meta.touched && meta.error && (
  <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
    </div>


              </div>
<div className="flex w-full justify-between items-center gap-4 ">

{/* Ticker name Input field */}
<div className="gap-2 w-full flex flex-col ">
<Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="designation">Designation<span className=" text-red-600">*</span></Label>
  <Field
    id="designation"
    type="text"
    name="designation"
    placeholder="Enter Designation"
    actionType={actionType}
    info={employeeInfo &&   employeeInfo?.designation}
    disabled={(actionType==="View"  ) && true}
    validate={
        (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
      }        
    component={renderField} // Correct usage of renderField
    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />
  {/* Reserve space for the error message */}
  {meta.touched && meta.error && (
<p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
</div>





</div>
              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="flex flex-col  w-full gap-2">
                  <AdvancedDropdown
                    name="Scheme"
                    id="scheme"
                    options={schemeOption}
                    selectedOptions={selectedSchemeOptions}
                    setSelectedOptions={setSelectedSchemeOptions}
                    placeholder="Scheme"
                    select={"single"}
                    disabled={actionType === "View" && true}
                    required={true}
                  />
                  {errors.schemeError && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{errors.schemeError}
                    </p>
                  )}

{ combinationOfSchemeAndClass?.length>0 && 
  (
  <div className="flex w-full  items-center gap-4 border border-[#3a5dd1] rounded-lg  p-10 flex-wrap ">
    {combinationOfSchemeAndClass?.length > 0 && combinationOfSchemeAndClass.map((item, index) => (
        <div   key={index} className="flex gap-8 justify-center items-center bg-[#0D215C] text-white text-sm rounded-xl px-4 py-2 font-bold  ">
          <span>{item}</span>
          <div className="rounded-full bg-red-500  flex items-center justify-center h-5 w-5 p-1 text-xs cursor-default " onClick={actionType !== 'View' ? () => handleRemoveCombinationOfSchemeAndClass(index) : undefined} >{"X"}

          </div>
          </div>
      ))}
    </div>
    )
    }

                </div>
   
                {/* <div className="flex flex-col  w-[49%] gap-2  ">
                  <AdvancedDropdown
                    name="Class"
                    id="class"
                    options={classOption}
                    selectedOptions={selectedClassOptions}
                    setSelectedOptions={setSelectedClassOptions}
                    placeholder="Class"
                    select={"single"}
                    disabled={selectedSchemeOptions.length === 0 && true}
                  />
                  {errors.classError && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{errors.classError}
                    </p>
                  )}
                </div> */}
              </div>

              {/* <div className="flex w-full justify-between items-center gap-4 ">
               

                <div className="flex flex-col  w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Investor"
                    id="investor"
                    options={investorOption}
                    selectedOptions={selectedInvestorOptions}
                    setSelectedOptions={setSelectedInvestorOptions}
                    placeholder="Investor"
                    select={"single"}
                    disabled={
                      (selectedClassOptions.length === 0 ||
                        selectedSchemeOptions.length === 0) &&
                      true
                    }
                  />
                  {errors.investorError && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{errors.investorError}
                    </p>
                  )}
                </div>
              </div> */}
              {/* { selectedInvestorAgainstSchemeAndClass?.length>0 && 
  (
  <div className="flex w-full  items-center gap-4 border border-[#3a5dd1] rounded-lg  p-10 flex-wrap ">
    {selectedInvestorAgainstSchemeAndClass?.length > 0 && selectedInvestorAgainstSchemeAndClass.map((item, index) => (
        <div   key={index} className="flex gap-8 justify-center items-center bg-[#0D215C] text-white text-sm rounded-xl px-4 py-2 font-bold  ">
          <span>{item}</span>
          <div className="rounded-full bg-red-500  flex items-center justify-center h-5 w-5 p-1 text-xs cursor-default " onClick={actionType !== 'View' ? () => handleRemoveSchemeAndClass(index) : undefined} >{"X"}

          </div>
          </div>
      ))}
    </div>
    )
    } */}
              <div className="w-full h-2 rounded-md bg-muted "></div>
              <div className="flex w-full justify-end gap-2">
              { ( actionType!=="View" && actionType!=="Edit")  &&  <div className=" w-[20%] h-10 gap-2">
                  <AdvancedDropdown
                    name="Email Template"
                    id="emailTemplate"
                    options={emailTemplateOption}
                    selectedOptions={selectedEmailTemplateOptions}
                    setSelectedOptions={setSelectedEmailTemplateOptions}
                    placeholder="Email Template"
                    select={"single"}
                    label={false}
                    //    disabled={selectedSchemeOptions.length===0 && true}
                  />
                </div>}
               { actionType!=="View" && <Button
                  type="submit"
                  className="w-[20%] h-10 bg-[#0D215C] self-end "
                >
                  {actionType==="Edit" ?"Save Changes" : "Create User"}
                </Button>}
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};

export default CreateEmployee;
